import { cn } from '@/common/utils/cn'
import { ReactNode } from 'react'

interface CardInfoCellProps {
  label: string
  children: ReactNode
  className?: string
}

export const CardInfoCell = ({ label, children, className }: CardInfoCellProps) => {
  return (
    <div className={cn('bg-white-200 rounded-md p-3 flex flex-col gap-1', className)}>
      <span className="text-[10px]">{label}</span>

      <div className="flex items-center gap-2">{children}</div>
    </div>
  )
}
